import { useBrandName } from '@brightdrop/bd-ui/brand';
import { useEffect } from 'react';

/**
 * Sets the document title to `<brand> - <title>` (or just `<brand>`), where the
 * brand label is resolved from the rebrand flag so it stays legacy when off.
 */
const usePageTitle = (title?: string): void => {
  const brandName = useBrandName();

  useEffect(() => {
    document.title = title ? `${brandName} - ${title}` : brandName;

    return () => {
      document.title = brandName;
    };
  }, [title, brandName]);
};

export default usePageTitle;
